export default function handleNavigation() {
    const navOpenClass = 'nav-active';

    $('body').on('click', '.js-toggle-navigation', () => {
        $('body').toggleClass(navOpenClass);
        $('.sub-nav-active').removeClass('sub-nav-active');
        return false;
    }).on('click', '.js-show-dropdown', function () {

        if ($(window).outerWidth() >= 1024) {
            return;
        }

        let $this = $(this);
        $this.parents('.js-nav-item').addClass('sub-nav-active');
        return false;
    }).on('click', '.js-hide-dropdown', function () {
        if ($(window).outerWidth() >= 1024) {
            return;
        }
        let $this = $(this);
        $this.parents('.js-nav-item').removeClass('sub-nav-active');
        return false;
    });
}